export var FireblocksExternalWalletPoolTypeEnum;
(function (FireblocksExternalWalletPoolTypeEnum) {
    FireblocksExternalWalletPoolTypeEnum["WITHDRAWAL"] = "WITHDRAWAL";
    FireblocksExternalWalletPoolTypeEnum["DEPOSIT"] = "DEPOSIT";
})(FireblocksExternalWalletPoolTypeEnum || (FireblocksExternalWalletPoolTypeEnum = {}));
//# sourceMappingURL=fireblocks-external-wallet-pool-type.enum.js.map